import React from 'react';
import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Home from "./headerMenu/Home";
import WelcomePage from "./emr/WelcomePage";
import UserAndPatientForm from "./form/UserAndPatientForm";
import EmrFooter from "./headerMenu/EmrFooter";
import "./style/emr_overall_style.scss";
import PrivacyPolicy from "./headerMenu/PrivacyPolicy";
import UserManagement from "./headerMenu/UserManagement";

function App() {
    return (
        <BrowserRouter basename="/">
            <div className="app-container">
                <div className="content">
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/dashboard/userAndPatientForm" element={<UserAndPatientForm/>}/>
                        <Route path="/welcome" element={<WelcomePage/>}/>
                        <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
                        <Route path="/userManagement" element={<UserManagement/>}/>
                    </Routes>
                </div>
                <EmrFooter/>
            </div>
        </BrowserRouter>
    );
}

export default App;
